export const overflowTruckingVendors = {
  '=0': 'No Overflow Trucking Vendors',
  '=1': '1 Overflow Trucking Vendor',
  other: '# Overflow Trucking Vendors',
};
